/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Companydetailslegalname3Inputs */

const en_companydetailslegalname3 = /** @type {(inputs: Companydetailslegalname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company or club name`)
};

const de_companydetailslegalname3 = /** @type {(inputs: Companydetailslegalname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firmenname oder Vereinsname`)
};

/**
* | output |
* | --- |
* | "Company or club name" |
*
* @param {Companydetailslegalname3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const companydetailslegalname3 = /** @type {((inputs?: Companydetailslegalname3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Companydetailslegalname3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_companydetailslegalname3(inputs)
	return de_companydetailslegalname3(inputs)
});
export { companydetailslegalname3 as "companyDetailsLegalName" }